const textFieldUserMyAccount = {
  nameHelp: 'Enter your full name',
  password: 'Current password',
  passwordNew: 'New password',
  passwordError: 'Minimum of 6 characters',
  passwordNew2: 'Repeat New Password',
  PasswordNewError2: 'Different passwords'
};

export default textFieldUserMyAccount;
